var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup58670(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58670",
    "data-name": "Group 58670",
    transform: "translate(-20740 -3390)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4487",
    "data-name": "Ellipse 4487",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(20740 3390)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete_1_",
    "data-name": "delete (1)",
    transform: "translate(20769.893 3413.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86420",
    "data-name": "Path 86420",
    d: "M47.853,153.4H27.581a5.9,5.9,0,0,1-5.9-5.9V115.613H53.757V147.5A5.9,5.9,0,0,1,47.853,153.4Zm0,0",
    transform: "translate(-19.609 -104.591)",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86422",
    "data-name": "Path 86422",
    d: "M34.246,4.33h-8.6L24.232,1.5A2.692,2.692,0,0,0,21.811,0H14.4a2.691,2.691,0,0,0-2.421,1.5L10.566,4.33h-8.6A1.968,1.968,0,0,0,0,6.3V9.054a1.968,1.968,0,0,0,1.968,1.968H34.246a1.968,1.968,0,0,0,1.968-1.968V6.3A1.968,1.968,0,0,0,34.246,4.33ZM13.3,2.156a1.223,1.223,0,0,1,1.1-.68h7.408a1.223,1.223,0,0,1,1.1.68L24,4.33H12.216Zm0,0",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55747",
    "data-name": "Group 55747",
    transform: "translate(7.085 20.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86424",
    "data-name": "Path 86424",
    d: "M266.226,236.018a1.968,1.968,0,0,1-1.968-1.968v-18.4a1.968,1.968,0,0,1,3.936,0v18.4A1.968,1.968,0,0,1,266.226,236.018Zm0,0",
    transform: "translate(-246.15 -213.68)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86425",
    "data-name": "Path 86425",
    d: "M76.289,236.018a1.968,1.968,0,0,0,1.968-1.968v-18.4a1.968,1.968,0,0,0-3.937,0v18.4A1.968,1.968,0,0,0,76.289,236.018Zm0,0",
    transform: "translate(-74.32 -213.68)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86426",
    "data-name": "Path 86426",
    d: "M171.257,236.018a1.968,1.968,0,0,1-1.968-1.968v-18.4a1.968,1.968,0,0,1,3.936,0v18.4A1.968,1.968,0,0,1,171.257,236.018Zm0,0",
    transform: "translate(-160.235 -213.68)",
    fill: "#ffafaf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup58670);
export default __webpack_public_path__ + "static/media/group_58670.7355c511dfff2f0b029d7151708ecb30.svg";
export { ForwardRef as ReactComponent };